module.exports = __webpack_public_path__ + "img/medalha-master.16c2dddd.jpg";